import { FC, memo, ReactNode, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import LicenseContext from 'src/contexts/LicenseContext';

import AsyncJobSnackbar from './AsyncJobsSnackbar';

type Props = {
  children: ReactNode;
};

const WithoutAppBarLayout: FC<Props> = memo((
  {
    children
  }
) => {
  const licenseContext = useContext(LicenseContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!licenseContext.initialized) return;
    if (licenseContext.authenticated) return;

    // eslint-disable-next-line no-void
    void navigate('/login');
  }, [licenseContext.initialized, licenseContext.authenticated]);

  return (
    <>
      {children}
      <AsyncJobSnackbar />
    </>
  );
});

export default WithoutAppBarLayout;
